
const digest = '04f15dff3b1de2ac2b40afb80dbcd53fc9e8d89493c2601a176c2c803a6bf865';
const classes = {"wrapper":"_wrapper_piuih_1","teeth":"_teeth_piuih_12","number":"_number_piuih_16","reverse":"_reverse_piuih_22"};
const css = `._wrapper_piuih_1 {
  font-family: Rubik, "sans-serif";
  display: flex;
  flex-direction: column;
  gap: 20px;
  position: relative;
  width: 100%;
}
._wrapper_piuih_1 :hover {
  cursor: pointer;
}
._wrapper_piuih_1 ._teeth_piuih_12 {
  display: flex;
  flex-direction: column;
}
._wrapper_piuih_1 ._number_piuih_16 {
  font-size: 14px;
  font-weight: 400;
  text-align: center;
}

._reverse_piuih_22 {
  flex-direction: column-reverse;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  